'use es6';

import { UPDATE_CONTENT_MODEL_THEME_PAGE_OVERRIDES, CLEAR_UPDATED_THEME_SETTINGS } from 'ContentEditorUI/redux/actions/actionTypes';
export const updateThemePageOverrides = (values, fieldKey) => ({
  type: UPDATE_CONTENT_MODEL_THEME_PAGE_OVERRIDES,
  payload: {
    fieldKey,
    values
  }
});
export const clearOverriddenThemeSettings = () => ({
  type: CLEAR_UPDATED_THEME_SETTINGS
});